class SystemHealthController {
    constructor($window, $browser, toastr, UserDetails, ngProgressFactory, AppServiceApi, TestAPIServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.emailSending = false;
            this.rufUrl = 'RUF/system/health?embed=true';
            // Initialise progress bar
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.traceProgress.start();
            this.AppServiceApi.settings().then((response) => {
                this.responseAppSettings = response.data;
                this.enableRUF = this.responseAppSettings.EnableRUF && this.responseAppSettings.EnableRUFComponents.some(c => c.toLowerCase() === 'systemhealth');
                this.UserDetails.get().then((data) => {
                    this.traceProgress.complete();
                    this.userDetails = data;
                }, () => {
                    this.traceProgress.complete();
                    this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                    this.window.location.href =
                        this.browser.baseHref() + 'account/login';
                    return;
                });
            });
            return;
        };
        this.sendEmail = (fromEmailAddress, toEmailAddresses, subject, message) => {
            this.emailSending = true;
            this.TestApiService.sendTestEmail(fromEmailAddress, toEmailAddresses, subject, message).then((response) => {
                this.emailSending = false;
                let result = response.data;
                if (result.errors.length > 0) {
                    for (let res of result.errors) {
                        this.toastr.error(res);
                    }
                }
                else {
                    this.toastr.info('Email sent');
                }
            });
        };
        this.window = $window;
        this.browser = $browser;
        this.toastr = toastr;
        this.ngProgressFactory = ngProgressFactory;
        this.AppServiceApi = AppServiceApi;
        this.UserDetails = UserDetails;
        this.TestApiService = TestAPIServiceApi;
    }
}
angular.module('app').component('systemHealth', {
    bindings: {},
    templateUrl: 'scripts/app/partials/SystemHealth/system-health.tpl.html',
    controllerAs: 'vm',
    controller: SystemHealthController,
});
